<template>
  <div class="group__info margin-top-10 padding-bottom-10">
    <div class="title font-size__medium">{{ title }}</div>
    <div class="content">
      <div class="form-input">
        <template>
          <el-table
            class="table detailRelatedDocs"
            style="width: 100%;"
            :data="vbOpinionForms"
            size=""
            v-if="vbOpinionForms && vbOpinionForms.length"
          >
            <el-table-column align="center" header-align="left" width="60">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.isActive"
                  @change="changePYKStatus($event, scope.row)"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="Nội dung" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-upload
                  v-show="!scope.row.attachDocumentId && scope.row.isActive"
                  :action="uploadAttachmentURL"
                  :on-success="attach => onUploadSuccess(attach, scope.row)"
                  :data="uploadVbOpinionFormAdditionalData"
                  :show-file-list="false"
                  :headers="uploadAttachmentHeaders"
                  :before-upload="
                    file =>
                      validateUploadFile(
                        file,
                        {
                          acceptFileTypes: DEFAULT_ACCEPTED_CONTENT_TYPE_DOC_OUT
                        },
                        buildMessageUploadOnlyPdf()
                      )
                  "
                  :on-error="onUploadError"
                  :on-change="() => (isUploadingVbOpinionFormFlag = true)"
                  v-loading="isUploadingVbOpinionFormFlag && isUploading"
                >
                  <el-button
                    :class="[
                      'el-button el-button--default padding-5',
                      scope.row.hasError ? 'btn-error' : ''
                    ]"
                  >
                    <i class="fas fa-cloud-upload-alt"></i>
                    &nbsp;Tải phiếu ý kiến
                  </el-button>
                  <span
                    v-show="scope.row.hasError"
                    class="font-size__tiny color__red"
                    >Chưa tải phiếu ý kiến</span
                  >
                </el-upload>
                <div>
                  <el-input
                    v-show="scope.row.attachDocumentId && scope.row.isActive"
                    class="style-fullWidth inputBg__white"
                    size="mini"
                    v-model="scope.row.content"
                  >
                    <i
                      slot="suffix"
                      class="el-icon-circle-close font-size__large color__red clickable"
                      @click="removeAttachment(scope.row)"
                    ></i>
                  </el-input>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Người cho ý kiến"
              width="300"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <el-input
                  class="style-fullWidth inputBg__white"
                  size="mini"
                  v-model="scope.row.fullName"
                  :disabled="true"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import FileTypeImage from "../job/FileTypeImage";
import constants from "../../constants";
import h from "../../services/h";
import utils from "../../services/utils";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import uploadFileMixin from "../doc-in/uploadFileMixin";
import DialogAddDocs from "../job/create-job/dialog-add-docs";
import userDeptRoleViewService from "../../services/userDeptRoleViewService";
import vbOpinionFormService from "../../services/vbOpinionFormService";
import errorMessageFilter from "../../filters/errorMessageFilter";
import Vue from "vue";

export default {
  name: "phieu-ykien-form",
  mixins: [handleRequestErrorMixin, uploadFileMixin],
  components: { DialogAddDocs, FileTypeImage },
  props: ["title", "docId", "categoryCode"],

  data() {
    return {
      DEFAULT_ACCEPTED_CONTENT_TYPE_DOC_OUT:
        constants.DEFAULT_ACCEPTED_CONTENT_TYPE_DOC_OUT,
      attachedType: constants.DOC_RELATION_ATTACHED_TYPE.PHIEU_Y_KIEN,
      vbOpinionForms: [],
      docRelationTypes: null,
      isUploadingVbOpinionFormFlag: null,
      uploadVbOpinionFormAdditionalData: {
        objectType: constants.ATTACHMENT_OBJECT_TYPE.PHIEU_Y_KIEN
      },
      defaultRelationType: null,
      isOpenAddDocDialog: false,
      isEnableAddDocDialog: false,
      docIds: [],
      listUserPYK: []
    };
  },

  watch: {
    isOpenAddDocDialog(newValue) {
      newValue && (this.isEnableAddDocDialog = newValue);
    },
    docId() {
      this.loadListUserPYK();
    },
    categoryCode(){
      this.loadListUserPYK();
    }
  },

  created() {
    this.loadListUserPYK();
  },

  methods: {
    changePYKStatus(value, row) {
      if (!value) {
        this.$set(row, "attachDocumentId", null);
        this.$set(row, "content", null);
      }
    },

    removeAttachment(row) {
      Vue.set(row, "attachDocumentId", null);
      Vue.set(row, "content", null);
      Vue.set(row, "id", null);
      Vue.set(row, "false", null);
    },

    populateVbOpinionForm(userDeptRoleView) {
      return {
        hasError: false,
        isActive: true,
        docId: this.docId,
        userDeptRoleId: userDeptRoleView.id,
        roleId: userDeptRoleView.roleId,
        userId: userDeptRoleView.userId,
        deptId: userDeptRoleView.deptId,
        fullName: userDeptRoleView.fullName
      };
    },

    loadListUserPYK() {
      console.log(this.categoryCode);
      let deptCode = constants.HDTV_DEPT_CODE;
      if (this.categoryCode &&
        (this.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_BTVDU
          || this.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_BTVDU)
      ) {
        deptCode = constants.TVDU_DEPT_CODE;
      } else if (this.categoryCode &&
        (this.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_BKTDU
          || this.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_BKTDU)
      ) {
        deptCode = constants.UBKT_DEPT_CODE;
      } else if (this.categoryCode &&
        (this.categoryCode === constants.CATEGORY_CODE.TO_TRINH_XIN_Y_KIEN_HDTDKT
          || this.categoryCode === constants.CATEGORY_CODE.GIAI_TRINH_Y_KIEN_HDTDKT)
      ) {
        deptCode = constants.HDTDKT_DEPT_CODE;
      }
      return userDeptRoleViewService
        .findAll(
          {
            deptCode: deptCode,
            roleCode: constants.ROLE.CODE.LANH_DAO
          },
          { sort: "fullName,asc" }
        )
        .then(res => {
          this.listUserPYK = res.data;
          if (this.listUserPYK)
            this.listUserPYK.sort((a, b) => utils.compareUserDeptRoleView(a, b));
          this.vbOpinionForms = h.collect(this.listUserPYK, userDeptRoleView =>
            this.populateVbOpinionForm(userDeptRoleView)
          );
        })
        .then(() =>
          this.docId ? this.loadVbOpinionForms() : Promise.resolve()
        )
        .then(() => {
          //remove & set active = false vb VbOpinionForms
          this.vbOpinionForms = h.findAll(
            this.vbOpinionForms,
            vbOpinionForm => {
              if (vbOpinionForm.attachDocumentId) return true;
              let userDeptRoleView = h.find(
                this.listUserPYK,
                userDeptRoleView =>
                  userDeptRoleView.id === vbOpinionForm.userDeptRoleId
              );
              return (
                userDeptRoleView &&
                (constants.USER_DEPT_ROLE.STATUS.ACTIVE ===
                  userDeptRoleView.status &&
                  constants.USERS.STATUS.ACTIVE ===
                    userDeptRoleView.usersStatus)
              );
            }
          );

          if (this.docId) {
            h.each(this.vbOpinionForms, vbOpinionForm =>
              Vue.set(
                vbOpinionForm,
                "isActive",
                !!vbOpinionForm.attachDocumentId
              )
            );
          }
        });
    },

    loadVbOpinionForms() {
      return vbOpinionFormService.findByDocId(this.docId).then(response => {
        h.each(response.data, vbOpinionForm => {
          //binding từ dữ liệu đã lưu vào form;
          let vbOpinionForms_ = h.find(
            this.vbOpinionForms,
            vbOpinionForms_ =>
              vbOpinionForms_.userDeptRoleId === vbOpinionForm.userDeptRoleId
          );
          if (vbOpinionForms_) {
            Vue.set(
              vbOpinionForms_,
              "attachDocumentId",
              vbOpinionForm.attachDocumentId
            );
            Vue.set(vbOpinionForms_, "content", vbOpinionForm.content);
            Vue.set(vbOpinionForms_, "id", vbOpinionForm.id);
          }
        });
      });
    },

    getVbOpinionForms() {
      return this.vbOpinionForms.filter(opinion => opinion.isActive);
    },

    validate() {
      console.log("!2312313");
      let vbOpinionForms = this.getVbOpinionForms();
      let isOk = true;
      h.each(vbOpinionForms, form => {
        if (!form.attachDocumentId) {
          form.hasError = true;
          isOk = false;
        }
      });
      return isOk;
    },

    buildMessageUploadOnlyPdf() {
      return errorMessageFilter({ errorCode: "file.onlyAllowPdfType" });
    },

    onUploadSuccess(vbAttachment, vbOpinionForm) {
      this.isUploading = false;
      vbOpinionForm.attachDocumentId = vbAttachment.id;
      vbOpinionForm.content = vbAttachment.fileName;
      vbOpinionForm.hasError = false;
    }
  }
};
</script>

<style scoped>
.btn-error {
  border-color: red;
}

.el-icon-circle-close {
  top: 5px;
  right: 0;
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/phieu-ykien-form.vue